/**
 * 描述：头条稿
 * 日期：2018-1-24
 * 作者：lileilei
 */
"use strict";
angular.module("resCenToutiaoLeftModule", [])
    .directive("toutiaoLeft", ["$state", "resourceCenterService", "$q", "$timeout", "$stateParams", "trsHttpService", function($state, resourceCenterService, $q, $timeout, $stateParams, trsHttpService) {
        return {
            replace: false,
            restrict: "E",
            scope: {
                firstNav: "="
            },
            templateUrl: "./networkResource/featuredResource/toutiao/left/left.html",
            link: function($scope, $elem, $attrs) {
                initStatus();
                initData();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {};
                }
                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    initSelect();
                }
                /**
                 * [stopPropagation description] 阻止冒泡
                 * @return {[type]} [description]
                 */
                $scope.stopPropagation = function(event) {
                    event.stopPropagation();
                };
                /**
                 * [firstNavSelected description] 判断一级菜单是否选中
                 * @param {object} [items] [description] 一级菜单
                 * @return {[type]} [description]
                 */
                $scope.firstNavSelected = function(items) {
                    if ($scope.status.selectedNav != undefined) {
                        return items.media_id === $scope.status.selectedNav.media_id ? 'active' : '';
                    } else {
                        return "";
                    }
                };
                /**
                 * [initSelect description] 初始化选择
                 * @param {object} [items] [description] 
                 * @return {[type]} [description]
                 */
                // $scope.initSelect = function(item) {
                //     if (window.location.href.indexOf("toutiao") < 0) {
                //         goTo('', -1, 'toutiao');
                //         return;
                //     }
                //     if ($stateParams.nodeid === item.media_id) {
                //         $scope.status.selectedNav = item;
                //         goTo(item, item.media_id, item.name);
                //         return;
                //     }
                // };
                function initSelect() {
                    if ($stateParams.onlyExpand) {
                        goTo('', -1, 'toutiao');
                        $scope.$parent.$parent.selectedStatus = -1;
                        return;
                    }
                    var flag = false;
                    for (var i in $scope.firstNav) {
                        var nav = $scope.firstNav[i];
                        if (nav.media_id === $stateParams.nodeid) {
                            $scope.status.selectedNav = nav;
                            flag = true;
                            break;
                        }
                    }
                    if (!flag) {
                        goTo('', -1, 'toutiao');
                        $scope.$parent.$parent.selectedStatus = -1;
                    }
                }

                /**
                 * [clickSecond description] 点击二级分类
                 * @param {object} [item] [description] 二级分类信息
                 * @return {[type]} [description]
                 */
                $scope.selectMedia = function($event, item) {
                    $event.stopPropagation();
                    goTo(item, item.media_id, item.name);
                };
                /**
                 * [goTo description] 路由切换
                 * @return {[type]} [description]
                 */
                function goTo(item, id, name) {
                    $scope.status.selectedNav = item;
                    resourceCenterService.go("front.networksource.featuredresource.toutiao.resource", {
                        nodeid: id,
                        nodename: name
                    });
                }
            }
        };
    }]);